export interface ApiSettings {
  contact: SettingsData;
  discover: SettingsData;
  home: SettingsData;
  player: SettingsData;
}

interface SettingsData {
  blocks: ApiBlockSettings[];
  slides: ApiSlideSettings[];
}

export class ApiSlideSettings {
  ID: string;
  copyright: string;
  date_maj: string;
  nom_pic: string;
  page: string;
  rank: number;
  url?: string;

  constructor(settings: SlideSettings) {
    this.ID = settings.reference;
    this.copyright = settings.copyright;
    this.date_maj = settings.lastModified;
    this.nom_pic = settings.fileName;
    this.page = settings.page;
    this.rank = settings.rank;
  }
}

export class SlideSettings {
  reference: string;
  copyright: string;
  lastModified: string;
  fileName: string;
  page: string;
  rank: number;

  constructor(apiSettings: ApiSlideSettings) {
    this.reference = apiSettings.ID;
    this.copyright = apiSettings.copyright;
    this.lastModified = apiSettings.date_maj;
    this.fileName = apiSettings.nom_pic;
    this.page = apiSettings.page;
    this.rank = apiSettings.rank;
  }
}

export class BlockSettings {
  ID: string;
  blocksubtitle: string;
  blocktext: string;
  blocktitle: string;
  date_maj: string;
  nom_pic: string;
  page: string;
  rank: number;
}

export class ApiBlockSettings {
  ID: string;
  blocksubtitle: string;
  blocktext: string;
  blocktitle: string;
  date_maj: string;
  nom_pic: string;
  page: string;
  rank: number;

  constructor(settings: BlockSettings) {
    this.ID = settings.ID;
    this.blocksubtitle = settings.blocksubtitle;
    this.blocktext = settings.blocktext;
    this.blocktitle = settings.blocktitle;
    this.date_maj = settings.date_maj;
    this.nom_pic = settings.nom_pic;
    this.page = settings.page;
    this.rank = settings.rank;
  }
}
